import $ from 'jquery';

function toggle(state) {
  switch (state) {
    case 'show':
      $(`.navbar-toggle[aria-expanded='false']`).click();
      return state;
    case 'hide':
      $(`.navbar-toggle[aria-expanded='true']`).click();
      return state;
    default:
      break;
  }
  return false;
}

export default {
  toggle
};



// WEBPACK FOOTER //
// ./src/services/navbar/NavbarService.js